import React from 'react';
import { Link } from 'react-router-dom';
import styles from './index.module.scss';

export default function Logo({ image, text, url }) {
    return (
        <div className="logo">
            <Link to={url || '/'} className={styles.logo}>
                {image && <img src={image} alt="logo" />}
                <span>{text}</span>
            </Link>
        </div>
    );
}
